<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(previewTitle)"
        :before-close="previewDialogClose"
        :visible.sync="dialogVisible"
        width="1180px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
    >
        <el-container>
            <el-form class="previewFormWith" ref="dynamicPreviewForm">
                <td-preview
                    ref="tdPreview"
                    :processDefintionId="templateKey"
                    :taskLinkId="taskKey"
                    :processNumber="processId"
                    :taskId="taskId"
                    :parentFunc="previewDialogClose"
                    :groupElement="groupElement"
                ></td-preview>
                <!-- <td-dynamic ref="tdDynamic" labelWidth="150px" :groupFlg="groupFlg" v-model="formValues"> </td-dynamic> -->
                <td-workflowhistory ref="tdHistory" labelWidth="100px" :processId="processId"></td-workflowhistory>
            </el-form>
        </el-container>
        <span slot="footer">
            <div>
                <td-workFlowButton
                    :sIng="sIng"
                    style="justify-content: center !important;"
                    ref="workFlowButton"
                    :dynamicBtn="dynamicBtn"
                    :loading="loading"
                    :cancel="previewDialogClose"
                ></td-workFlowButton>
            </div>
            <!-- <td-button @click="previewDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button> -->
        </span>
    </td-dialog>
</template>
<script>
import previewApi from './../assets/api.js';
export default {
    props: ['previewTitle', 'dialogVisible', 'templateKey', 'taskKey', 'groupElementValue'],
    created() {
        this.sIng = this.templateKey + ':' + this.taskKey;
    },
    // 定义变量
    data() {
        return {
            loading: false,
            groupElement: {},
            processId: '',
            taskId: '',
            submitLoading: false,
            // db表单信息
            formInfo: {},
            formValues: {}
        };
    },
    // 定义并实现方法体
    methods: {
        // 关闭窗口之前需要调用的方法
        previewDialogClose() {
            this.$emit('previewDialogClose');
        },
        dynamicBtn(sSeriesButtonList, btnName) {
            // console.log(this.$refs.tdPreview.validateForm());
            // this.$refs.tdPreview.validateForm();
            console.log(this.$refs.tdPreview.groupElement);
            console.log(btnName);
            // this.loading = true;
            // this.$refs.tdPreview.submitForm(sSeriesButtonList, '', btnName + '成功！');
        }
    }
};
</script>
<style scoped>
.previewFormWith {
    width: 100%;
}
</style>
